import * as Sentry from '@sentry/react'

const sentryDsn = import.meta.env.VITE_SENTRY_DSN

if (import.meta.env.PROD && sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    sendDefaultPii: true,
    environment: import.meta.env.MODE || 'production',
    release: import.meta.env.VITE_SENTRY_RELEASE || 'development',
    attachStacktrace: true,
  })
}
